import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import VerticalLabelList from '../../label/VerticalLabelList';
import FieldSet from '../../fieldset/FieldSet';

const IPBSLineItemPaymentRecordView = ({ selectedLineItem, }) => {
  const renderLineItemData = () => {
    const formattedLineItem = Object.keys(selectedLineItem)
      .filter(key => !!selectedLineItem[key])
      .reduce((obj, key) => {
        let value = selectedLineItem[key];
        if (typeof value === 'object') {
          value = JSON.stringify(value);
        } else {
          value = String(value);
        }
         
        obj[_.startCase(key)] = value;
        return obj;
      }, {});
    const items = VerticalLabelList.toList(formattedLineItem);
    const exclusions = [ 'Payable At Time Of Payment', ];

    return (
      <FieldSet title="Account Data" style={{ maxHeight: '400px', }}>
        <VerticalLabelList items={items} exclusions={exclusions} />
      </FieldSet>
    );
  };

  return (
    <>
      {renderLineItemData()}
    </>
  );
};

IPBSLineItemPaymentRecordView.propTypes = {
  selectedLineItem: PropTypes.instanceOf(Object).isRequired,
};

export default IPBSLineItemPaymentRecordView;
